module.exports = __webpack_public_path__ + "img/shiba-head-level2.3de3c6ad.png";